// extracted by mini-css-extract-plugin
export default {"wrapper":"Highlight-module--wrapper--TtlrG"};